import type { JsonSchema } from 'src/utils/jsonSchema';

import raw from './webhook.schema.json';

export const webhookSchema = raw as JsonSchema;
